import URI from "urijs";

const clientName = window.location.pathname.split("/")[1];

export const basename = "/" + clientName;

export const to = url => new URI(basename + url);

// Helper function to convert wildcard pattern to regex
export const wildcardToRegex = pattern => {
  // Escape special regex characters except * and ?
  const escaped = pattern.replace(/[.+^${}()|[\]\\]/g, "\\$&");
  // Replace wildcards: * -> .* and ? -> .
  const regexPattern = escaped.replace(/\*/g, ".*").replace(/\?/g, ".");
  // WHY: regexp is built from application-defined constants, not from user-controlled input
  // nosemgrep: javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp
  return new RegExp(`^${regexPattern}$`, "i");
};

// Helper function to validate origin against patterns
export const isOriginAllowed = (origin, allowedPatterns) => {
  // Ensure we're working with an array
  const patterns = Array.isArray(allowedPatterns)
    ? allowedPatterns
    : allowedPatterns
        .split(",")
        .map(p => p.trim())
        .filter(Boolean);

  return patterns.some(pattern => {
    try {
      // Direct match
      if (pattern === origin || pattern === "*") {
        return true;
      }

      // Wildcard pattern (contains * or ?)
      if (pattern.includes("*") || pattern.includes("?")) {
        const regex = wildcardToRegex(pattern);
        return regex.test(origin);
      }

      // Case-insensitive exact match as fallback
      return pattern.toLowerCase() === origin.toLowerCase();
    } catch (e) {
      // WHY: format string arguments are application-defined constants, not user-controlled input
      // nosemgrep: javascript.lang.security.audit.unsafe-formatstring.unsafe-formatstring
      console.warn(`Invalid pattern "${pattern}":`, e);
      return false;
    }
  });
};
